import { render, staticRenderFns } from "./TopLanguageSwitchModern.vue?vue&type=template&id=e2358240&scoped=true&"
import script from "./TopLanguageSwitchModern.vue?vue&type=script&lang=js&"
export * from "./TopLanguageSwitchModern.vue?vue&type=script&lang=js&"
import style0 from "./TopLanguageSwitchModern.vue?vue&type=style&index=0&id=e2358240&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2358240",
  null
  
)

export default component.exports